import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DetailProduct from "../components/detail/DetailProduct";
import ProductInfo from "../components/detail/ProductInfo";
import RelatedProduct from "../components/detail/RelatedProduct";
import baseUrl from "../url/baseUrl";
import { useSelector } from "react-redux";
import Modal from "../components/modal/Modal";

import "./DetailPage.css";

// component hiển thị thông tin chi tiết 1 sản phẩm
function DetailPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true); // Add a loading state

  const isModalOpen = useSelector((state) => state.popup.isModalOpen);
  const params = useParams();

  // Fetch data synchronously
  useEffect(() => {
    fetch(`${baseUrl}/products/${params.productId}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Something went wrong with fetch products!");
        }
        return response.json();
      })
      .then((productItem) => {
        setProducts(productItem);

        setLoading(false); // Data is available, set loading to false
      })
      .catch((err) => {
        console.log(err);
      });
  }, [params.productId]);

  // ban đầu loading là true thì hiện text loading đợi đến khi dữ liệu trả về thì set loading thành false
  if (loading) {
    // Show a loading indicator or message
    return <div className="text-danger">Loading...</div>;
  }

  const selectProd = products.selectProd;

  const relatedProd = products.relatedProd;

  const imagesList = [
    selectProd.img1,
    selectProd.img2,
    selectProd.img3,
    selectProd.img4,
  ];

  return (
    <section>
      <div className="detail_page">
        <DetailProduct imagesList={imagesList} product={selectProd} />
        <ProductInfo product={selectProd} />
        <RelatedProduct product={relatedProd} />
      </div>
      {isModalOpen && <Modal />}
    </section>
  );
}

export default DetailPage;
